<style scoped>
.rotate-down {
    transform: rotate(90deg);
}
</style>

<template>
    <div
        class="relative flex flex-row items-center"
        v-click-outside="closeDropdown"
        @mouseover="mouseover"
        @mouseleave="mouseleave"
    >
        <button
            class="relative flex flex-row items-center overflow-hidden focus:outline-none header-btn"
        >
            <slot name="button">
                <div class="icon">
                    <svg
                        :class="{ 'rotate-down': isOpen }"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                    >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                        />
                    </svg>
                </div>
            </slot>
        </button>
        <div
            v-if="isOpen"
            class="absolute py-2 w-48 bg-white rounded-lg shadow-xl dropdown"
            :class="dropdownContainerClass"
        >
            <slot name="dropdown"> </slot>
        </div>
    </div>
</template>

<script>
import clickOutside from '../directives/clickOutside';

export default {
    directives: {
        clickOutside
    },
    props: {
        dropdownContainerClass: { default: 'right-0 ' },
        supportMouseover: { type: Boolean, default: false }
    },
    data() {
        return {
            isOpen: false
        };
    },
    beforeDestroy() {
        if (this.collapseTimeout) clearTimeout(this.collapseTimeout);
    },
    methods: {
        mouseover() {
            if (!this.supportMouseover) {
                return;
            }

            if (this.collapseTimeout) clearTimeout(this.collapseTimeout);
            this.isOpen = true;
        },
        mouseleave() {
            if (!this.supportMouseover) {
                return;
            }

            if (this.collapseTimeout) clearTimeout(this.collapseTimeout);
            this.collapseTimeout = setTimeout(() => {
                this.isOpen = false;
            }, 0.1 * 1000);
        },
        closeDropdown() {
            this.isOpen = false;
            if (this.collapseTimeout) clearTimeout(this.collapseTimeout);
        }
    }
};
</script>
